export const SEND_HTTP_REQUEST = '@@api/SEND_HTTP_REQUEST';
export const RESET_WEB_DATA = '@@api/RESET_WEB_DATA';
export const SEND_GRAPHQL_QUERY = '@@api/SEND_GRAPHQL_QUERY';

